<md-content-box class="enrollment-info-box">
	<div class="enrollment-info">
		<div class="enrollment-info__header">
			<md-icon icon="untitled-ui/general/translate-01"></md-icon>
			<md-header size="sm" variant="semibold">{{ languageName() }}</md-header>
		</div>
		@if (!isAwaitingSchedule()) {
			<div class="program-info">
				<div class="program-info__content">
					@if (currentEnrollment().instructorUserID) {
						<div class="instructor-avatar">
							<lb-user-icon [userID]="currentEnrollment().instructorUserID!"></lb-user-icon>
							<div class="user-info">
								<span class="user-info__top">
									{{ currentEnrollment().instructorFullName }}
								</span>
								<span class="user-info__bottom">Instructor</span>
							</div>
						</div>
					} @else {
						<lb-no-instructor />
					}

					<div class="program-details">
						<span class="program-details__top">{{ programName() }}</span>
						<span class="program-details__bottom">Level {{ languageLevel() }}</span>
					</div>
				</div>
			</div>

			<div class="schedule-info">
				<div>
					<span>{{ startDateLabel() }}</span>
					<span>{{ startDate() }}</span>
				</div>
				@if (endDate()) {
					<div>
						<span>{{ endDateLabel() }}</span>
						<span>{{ endDate() }}</span>
					</div>
				}

				<div class="center">
					<lb-enrollment-tag
						[enrollmentStatus]="currentEnrollment().enrollmentStatusName"
						[enrollmentStatusID]="currentEnrollment().enrollmentStatusID"
						[isLearner]="true"
					>
					</lb-enrollment-tag>
				</div>
			</div>

			@if (isAwaitingMatch()) {
				<div class="progress-info">
					<div class="awaiting-match-progress">
						<div class="success-icon">
							<md-icon icon="untitled-ui/general/check-circle"></md-icon>
						</div>
						<div class="content">
							<div class="message">
								<div class="title">We're matching you to an instructor</div>
								<div class="description">
									Your availability has been submitted and our team is now matching you with an instructor who fits your learning goals
									and schedule.
								</div>
							</div>
						</div>
					</div>
				</div>
			}

			@if (currentEnrollment().programSummary; as programSummary) {
				<lb-program-completion-summary [program]="programSummary"></lb-program-completion-summary>
			}
		} @else {
			<div class="schedule-cta">
				<div class="schedule-cta__icon">
					<md-icon icon="untitled-ui/time/calendar"></md-icon>
				</div>
				<div class="schedule-cta__body">
					<md-header size="sm" variant="semibold">Action Required: Set Up Your Lesson Schedule</md-header>
					<div class="schedule-cta__description">
						Your lessons cannot begin until your schedule is complete. Tell us your start date, preferred lesson times, and availability so we
						can match you with an instructor.
					</div>
					<a routerLink="/enrollments/{{ currentEnrollment().enrollmentID }}/schedule" md-button-brand class="cta-action-btn">
						Set Up My Lesson Schedule
						<md-icon icon="untitled-ui/arrows/chevron-right"></md-icon>
					</a>
					<div class="schedule-cta__time">
						<md-icon icon="untitled-ui/time/clock"></md-icon>
						<span>Takes about 3-5 minutes</span>
					</div>
				</div>
			</div>

			<div class="progress-info">
				<lrnr-scheduler-progress [orientation]="'horizontal'"></lrnr-scheduler-progress>
			</div>
		}
	</div>
</md-content-box>
